export const SolutionRouting = [
  {
    path: "/project/solution/list",
    name: "project-solution-list",
    meta: { title: "预算报价" },
    component: () => import("@/views/project/solution/list/index.vue"),
  },
  {
    hidden: true,
    path: "/project/solution/create",
    name: "project-solution-create",
    meta: { title: "新增预算报价", comName: "ProjectSolutionFormCreate" },
    component: () => import("@/views/project/solution/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/project/solution/edit/:id",
    name: "project-solution-edit",
    meta: { title: "编辑预算报价", comName: "ProjectSolutionFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "project-solution" */ "@/views/project/solution/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/solution/detail/:id",
    name: "project-solution-detail",
    meta: { title: "预算报价详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-solution" */ "@/views/project/solution/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/project/solution/flowPrint/:id",
    name: "project-solution-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/project/solution/flow-print/index.vue"
      ),
  },
];
